import { FieldErrors, UseFormRegister } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";
import Graph from "../Graph";

interface IInputsSetMaximums {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  formData: any;
  onBlurHandler: (event: any) => void;
}

function InputsSetMaximums(props: IInputsSetMaximums) {
  const { errors, register, formData, onBlurHandler } = props;

  return (
    <div>
      <div className="d-flex">
        <div className="mr-100">
          <p>Cycle Stroke</p>
          <div className="d-flex w-100px">
            <input
              className={errors.cycleStroke ? "input-error-checkbox" : ""}
              type="number"
              step="any"
              {...register("cycleStroke", {
                required: true,
                valueAsNumber: true,
                min: 100,
                onBlur: onBlurHandler,
                max: formData.travelDistance ?? 1,
              })}
            />
            <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
          </div>
          <small className="input-small-text">100 - Travel Distance mm</small>
        </div>
        <div className="mr-100">
          <p>Max Velocity</p>
          <div className="d-flex w-100px">
            <input
              className={errors.maxVelocity ? "input-error-checkbox" : ""}
              type="number"
              step="any"
              {...register("maxVelocity", {
                required: true,
                valueAsNumber: true,
                onBlur: onBlurHandler,
                min: 0.01,
                max: 8,
              })}
            />
            <p style={{ marginBottom: "0px", marginLeft: "5px" }}>m/s</p>
          </div>
          <small className="input-small-text">.01 - 8 m/s</small>
        </div>
        <div className="mr-100">
          <p>Max Acceleration</p>
          <div className="d-flex w-100px">
            <input
              className={errors.maxAcceleration ? "input-error-checkbox" : ""}
              type="number"
              step="any"
              {...register("maxAcceleration", {
                required: true,
                valueAsNumber: true,
                min: 0.001,
                onBlur: onBlurHandler,
                max: 50,
              })}
            />
            <p style={{ marginBottom: "0px", marginLeft: "5px" }}>m/s&sup2;</p>
          </div>
          <small className="input-small-text">.001 - 50 m/s&sup2;</small>
        </div>
        {/* {formData?.motionProfileShape !== "Simplified Input" && (
          <>
            <div className="mr-100">
              <p>Cycle Stroke</p>
              <div className="d-flex w-100px">
                <input
                  className={errors.cycleStroke ? "input-error-checkbox" : ""}
                  type="number"
                  step="any"
                  {...register("cycleStroke", {
                    required: true,
                    valueAsNumber: true,
                    min: 100,
                    onBlur: onBlurHandler,
                    max: formData.travelDistance ?? 1,
                  })}
                />
                <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
              </div>
              <small className="input-small-text">
                100 - Travel Distance mm
              </small>
            </div>
            <div className="mr-100">
              <p>Stroke Time</p>
              <br />
              <div className="d-flex w-100px">
                <input
                  className={errors.strokeTime ? "input-error-checkbox" : ""}
                  type="number"
                  step="any"
                  {...register("strokeTime", {
                    required: true,
                    valueAsNumber: true,
                    min: 0.1,
                    max: 9999,
                    onBlur: onBlurHandler
                  })}
                />
                <p style={{ marginBottom: "0px", marginLeft: "5px" }}>s</p>
              </div>
              <small className="input-small-text">.1 - 9999 s</small>
            </div>
            {formData?.motionProfileShape !== "Triangle" && (
              <>
                <div className="mr-100">
                  <p>Time @ Max V</p>
                  <div className="d-flex w-100px">
                    <input
                      className={
                        errors.timeAtMaxV ? "input-error-checkbox" : ""
                      }
                      type="number"
                      step="any"
                      {...register("timeAtMaxV", {
                        required: true,
                        valueAsNumber: true,
                        min: 0,
                        onBlur: onBlurHandler,
                        max: 9999,
                      })}
                    />
                    <p style={{ marginBottom: "0px", marginLeft: "5px" }}>s</p>
                  </div>
                  <small className="input-small-text">0 - 9999 s</small>
                </div>
                <div className="mr-100">
                  <p>Stroke @ Max V</p>
                  <div className="d-flex w-100px">
                    <input
                      className={
                        errors.strokeAtMaxV ? "input-error-checkbox" : ""
                      }
                      type="number"
                      step="any"
                      {...register("strokeAtMaxV", {
                        required: true,
                        valueAsNumber: true,
                        min: 0,
                        max: formData.travelDistance ?? 1,
                        onBlur: onBlurHandler
                      })}
                    />
                    <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
                  </div>
                  <small className="input-small-text">
                    0 - Travel Distance mm
                  </small>
                </div>
              </>
            )}
          </>
        )} */}
      </div>
      {/* <div>
        <Graph />
      </div> */}
    </div>
  );
}

export default InputsSetMaximums;
